import React from "react";
import styled from "styled-components";
import ImageTextTeaserComponent from "../../common/ImageTextTeaserComponent";
import EventFacts from "../../EventSlider/EventFacts";
import { media, spacing } from "../../theme";
import { Image } from "../../../lib/image";

export interface Props {
  headerImage?: Image;
  ctaHref: string;
  name: string;
  description: string;
  dates: { date: string; time: string }[];
  organizer?: string;
  location?: string;
  swap?: boolean;
}

const StyledImageTextTeaser = styled(ImageTextTeaserComponent)`
  max-width: ${p => (!p.image ? "80%" : "100%")};
  margin: 0 auto;
  @media screen and ${media.tablet} {
    max-width: 100%;
  }
  ${spacing("margin-bottom", 80)}
`;

export default function EventArticleTeaser(p: Props) {
  return (
    <StyledImageTextTeaser
      headline={p.name}
      text={p.description}
      ctaRef={{
        _ref: "content" as "content",
        _id: "0",
        _url: p.ctaHref
      }}
      ctaLabel="Zur Veranstaltung"
      image={p.headerImage}
      swap={p.swap}
      sublineElement={<EventFacts dates={p.dates} organizer={p.organizer} location={p.location} />}
    />
  );
}

EventArticleTeaser.getImages = (p: Props) => {
  return p.headerImage ? [p.headerImage] : [];
};
